<template>
  <WebPanel>
    <WebPanelDashboard :navigation="navigation">
      <router-view />
    </WebPanelDashboard>
  </WebPanel>
</template>

<script>
import WebPanel from '@sbvr/web-panel/WebPanel';
import WebPanelDashboard from '@sbvr/web-panel/WebPanelDashboard';

export default {
  name: 'App',
  components: {
    WebPanel,
    WebPanelDashboard,
  },
  computed: {
    navigation () {
      return [
        [
          {
            name: 'Colors',
            routerLink: { name: 'colors-index' },
            icon: 'settings',
          },
          {
            name: 'UI Components',
            routerLink: { name: 'ui-index' },
            icon: 'layers',
            children: [
              {
                name: 'Typography',
                routerLink: { name: 'ui-index' },
                icon: 'layers',
              },
              {
                name: 'Buttons',
                routerLink: { name: 'ui-buttons' },
                icon: 'layers',
              },
              {
                name: 'Inputs',
                routerLink: { name: 'ui-inputs' },
                icon: 'layers',
              },
              {
                name: 'Icons',
                routerLink: { name: 'ui-icons' },
                icon: 'layers',
              },
              {
                name: 'Modals',
                routerLink: { name: 'ui-modals' },
                icon: 'layers',
              },
              {
                name: 'Flashs Notifications',
                routerLink: { name: 'ui-flashs' },
                icon: 'layers',
              },
            ],
          },
          {
            name: 'SBVR Components',
            routerLink: { name: 'components-index' },
            icon: 'layers',
            children: [
              {
                name: 'ContentCard',
                routerLink: { name: 'content-card-index' },
                icon: 'layers',
              },
            ],
          },
          {
            name: 'Focus page',
            routerLink: { name: 'focus' },
            icon: 'settings',
          },
          {
            name: 'External link',
            externalLink: 'https://springboardvr.com',
            icon: 'settings',
          },
          {
            name: 'Action',
            action: () => alert('action'),
            icon: 'settings',
          },
          {
            name: 'Disable',
            action: () => alert('action'),
            disable: true,
            icon: 'settings',
          },
          {
            name: 'Notification',
            action: () => alert('action'),
            notification: 1,
            icon: 'settings',
          },
        ],
      ];
    },
  },
  // topLink = { name: 'home' };

  // get applications () {
  //   return [
  //     {
  //       name: 'Sidecar',
  //       url: '/',
  //       current: true,
  //     },
  //   ];
  // }
};
</script>

<style lang="postcss">
@import "@sbvr/styles/index.css";
</style>
